import { useState } from 'react'
import { Tabs } from '@arco-design/web-react'
import type { OptionsAPI } from './useOptions'
import GroupRatioJsonSection from './ratio/GroupRatioJsonSection'
import ModelRatioJsonSection from './ratio/ModelRatioJsonSection'
import UnsetModelsPricingEditor from './ratio/UnsetModelsPricingEditor'
import UpstreamRatioSyncSection from './ratio/UpstreamRatioSyncSection'
import VisualModelPricingEditor from './ratio/VisualModelPricingEditor'

const RATIO_TABS = [
  { key: 'model', title: '模型倍率设置', Comp: ModelRatioJsonSection },
  { key: 'group', title: '分组相关设置', Comp: GroupRatioJsonSection },
  { key: 'visual', title: '价格设置', Comp: VisualModelPricingEditor },
  { key: 'unset_models', title: '未设置价格模型', Comp: UnsetModelsPricingEditor },
  { key: 'upstream_sync', title: '上游倍率同步', Comp: UpstreamRatioSyncSection },
] as const

type RatioTabKey = (typeof RATIO_TABS)[number]['key']

export default function RatioSetting({ options }: { options: OptionsAPI }) {
  const [activeTab, setActiveTab] = useState<RatioTabKey>('visual')

  const ActiveComp = RATIO_TABS.find((t) => t.key === activeTab)?.Comp ?? VisualModelPricingEditor

  return (
    <div className="ratio-setting-page">
      <div className="settings-risk-alert settings-info-strip">
        修改分组倍率或模型定价会直接影响扣费与路由。固定价优先于按量倍率；auto 分组顺序影响渠道选择；错误 JSON 或负数会在保存前拦截。
      </div>

      <div className="ratio-setting-subtabs">
        <Tabs activeTab={activeTab} onChange={(k) => setActiveTab(k as RatioTabKey)} destroyOnHide={false}>
          {RATIO_TABS.map(({ key, title }) => (
            <Tabs.TabPane key={key} title={title} />
          ))}
        </Tabs>
      </div>

      <div className="ratio-setting-content">
        <ActiveComp options={options} />
      </div>
    </div>
  )
}
